import { required, useTranslate } from 'react-admin';
import { ConfigurationSettingsFields } from '@/components/global/forms/ConfigurationSettingsFields.jsx';
import { optionalCurrency, optionalDigits } from '@/components/retailChain/validators/retailChainValidators.js';

export const RetailChainConfiguration = () => {
    const translate = useTranslate();
    const requiredField = required(translate('common.validation.required'));
    const fieldLabel = key => translate(`resources.retailChain.fields.${key}`);

    return (
        <ConfigurationSettingsFields
            title={translate('resources.retailChain.labels.configuration')}
            fieldLabel={fieldLabel}
            operatorsValidate={requiredField}
            forwarderValidate={requiredField}
            methodsValidate={requiredField}
            validateCurrency={optionalCurrency(translate('resources.retailChain.validation.currency'))}
            validateDigits={optionalDigits(translate('resources.retailChain.validation.digits'))}
            limitTitle={translate('resources.retailChain.labels.discountLimits')}
            valueTitle={translate('resources.retailChain.labels.discountValues')}
            limitLabelKey='resources.retailChain.labels.discountLimit'
            valueLabelKey='resources.retailChain.labels.discountValue'
        />
    );
};

RetailChainConfiguration.propTypes = {};
